import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/reconditioners/:reconditionerId',
    name: 'reconditionerDetail',
    component: () =>
      import('@/views/restricted/recycling-module/reconditioner/ReconditionerDetailLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/reconditioners/create',
    name: 'reconditionerCreate',
    component: () =>
      import('@/views/restricted/recycling-module/reconditioner/ReconditionerCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_CREATE'],
      menuSelected: 'recycling'
    }
  },
  {
    path: '/reconditioners/:reconditionerId/edit',
    name: 'reconditionerUpdate',
    component: () =>
      import('@/views/restricted/recycling-module/reconditioner/ReconditionerUpdateView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_UPDATE'],
      menuSelected: 'recycling'
    }
  }
]
